import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { useFormContext } from 'react-hook-form'

import RadioGroup from '@mui/material/RadioGroup'

import { theme } from '../../themes/theme'
import { RowFormControl, StyledFormControlLabel, StyledRadio } from '../styles/RadioGroup'
import { FlexColumn } from '../styles/Containers'
import BodyText, { FormTitle } from '../styles/Text'
import StrataForm from './StrataForm'
import { InfoMessage } from '../common/UserMessage'
import pirTerminology from '../../util/pirTerminology'

const Red = styled.span`
  color: ${theme.colors.error};
`

function ManualStrata({ disabled = false, variant = 'public' }) {
  const { watch, register, getValues } = useFormContext()
  const [defaultStrata, setDefaultStrata] = useState()

  useEffect(() => {
    setDefaultStrata(getValues('strataState') || '')
  }, [])

  const strataState = watch('strataState')

  return (
    <FlexColumn>
      <FormTitle>{pirTerminology.getAssociationLabel('Information')}</FormTitle>
      {variant !== 'staff' && (
        <InfoMessage>
          If the information pertains only to a specific unit and not the entire building or common property, {pirTerminology.getAssociationTitle()}{' '}
          information is not required.
        </InfoMessage>
      )}
      <RowFormControl>
        <BodyText>
          Is this property part of a {pirTerminology.getAssociationLower()}?<Red> *</Red>
        </BodyText>
        {defaultStrata !== undefined && (
          <RadioGroup row name="owned-by-radio-group" id="strataState" defaultValue={defaultStrata}>
            <StyledFormControlLabel {...register('strataState')} value="manualStrata" control={<StyledRadio />} label="Yes" disabled={disabled} />
            <StyledFormControlLabel {...register('strataState')} value="manualNoStrata" control={<StyledRadio />} label="No" disabled={disabled} />
          </RadioGroup>
        )}
      </RowFormControl>
      {strataState === 'manualStrata' && <StrataForm disabled={disabled} />}
    </FlexColumn>
  )
}

ManualStrata.propTypes = {
  disabled: PropTypes.bool,
  variant: PropTypes.oneOf(['public', 'staff']),
  onUpdateStrataState: PropTypes.func
}

export default ManualStrata
